<div class="dl-navigation" [class.collapsed]="collapsed()">
  <nav class="d-flex flex-nowrap flex-column dl-nav">
    <!-- home -->
    <a class="dl-nav-link d-flex align-items-center overflow-hidden" routerLink="/home" routerLinkActive="active"
      matTooltip="Home" [matTooltipDisabled]="!collapsed()" matTooltipPosition="right">
      <div class="d-flex align-items-center justify-content-center dl-nav-icon-container">
        <mat-icon>home</mat-icon>
      </div>
      <span class="ms-2">Home</span>
    </a>
    <!-- DC -->
    <a class="dl-nav-link d-flex align-items-center overflow-hidden" routerLink="/data-collections" routerLinkActive="active"
      matTooltip="Data Collections" [matTooltipDisabled]="!collapsed()" matTooltipPosition="right">
      <div class="d-flex align-items-center justify-content-center dl-nav-icon-container">
        <mat-icon>library_books</mat-icon>
      </div>
      <span class="ms-2">Data Collections</span>
    </a>
    <!-- DUR -->
    <a class="dl-nav-link d-flex align-items-center overflow-hidden" routerLink="/data-utilization" routerLinkActive="active"
      matTooltip="Data Utilization Request" [matTooltipDisabled]="!collapsed()" matTooltipPosition="right">
      <div class="d-flex align-items-center justify-content-center dl-nav-icon-container">
        <mat-icon>insights</mat-icon>
      </div>
      <span class="ms-2">Data Utilization</span>
    </a>
    <!-- DU -->
    <a class="dl-nav-link d-flex align-items-center overflow-hidden" routerLink="/data-uploads" routerLinkActive="active"
      matTooltip="Data Uploads" [matTooltipDisabled]="!collapsed()" matTooltipPosition="right">
      <div class="d-flex align-items-center justify-content-center dl-nav-icon-container">
        <mat-icon>backup</mat-icon>
      </div>
      <span class="ms-2">Data Uploads</span>
    </a>
    <!-- VER -->
    <a class="dl-nav-link d-flex align-items-center overflow-hidden" routerLink="/virtual-environment" routerLinkActive="active"
      matTooltip="Virtual Environment" [matTooltipDisabled]="!collapsed()" matTooltipPosition="right">
      <div class="d-flex align-items-center justify-content-center dl-nav-icon-container">
        <mat-icon>cast</mat-icon>
      </div>
      <span class="ms-2">Virtual Environment</span>
    </a>
    <!-- toggle button -->
    <div class="d-flex justify-content-end w-100 py-1 mt-auto">
      <button type="button" mat-icon-button (click)="toggle()">
        <mat-icon [class.collapsed]="collapsed()">chevron_left</mat-icon>
      </button>
    </div>
  </nav>
</div>
